const heTosHtml = `<html><head>
<meta http-equiv="Content-Type" content="text/html; charset=windows-1252">
<meta name="Generator" content="Microsoft Word 15 (filtered)">
<style>
<!--
 /* Font Definitions */
 @font-face
	{font-family:"Cambria Math";
	panose-1:2 4 5 3 5 4 6 3 2 4;}
 /* Style Definitions */
 p.MsoNormal, li.MsoNormal, div.MsoNormal
	{margin:0cm;
	line-height:115%;
	font-size:11.0pt;
	font-family:"Arial",sans-serif;}
.MsoChpDefault
	{font-family:"Arial",sans-serif;}
.MsoPapDefault
	{line-height:115%;}
@page WordSection1
	{size:612.0pt 792.0pt;
	margin:72.0pt 72.0pt 72.0pt 72.0pt;}
div.WordSection1
	{page:WordSection1;}
 /* List Definitions */
 ol
	{margin-bottom:0cm;}
ul
	{margin-bottom:0cm;}
-->
</style>

</head>

<body lang="en-PK" style="word-wrap:break-word">

<div class="WordSection1">

<p class="MsoNormal" dir="RTL" style="margin-top:0;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><b><span lang="AR-SA">תנאי
שימוש של </span></b><b><span lang="EN" dir="LTR">Keilot</span></b><span lang="EN" dir="LTR"> </span><b><span lang="AR-SA">עדכון
אחרון:</span></b><span lang="AR-SA">
יוני 2025</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="EN" dir="LTR">&nbsp;</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">התנאים
הבאים ("<b>תנאי
שימוש</b>" או "<b>התנאים</b>")
מסדירים את
גישתך
ושימושך באתר
וביישום הנייד
של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>, לרבות
כל תוכן,
פונקציונליות
ושירותים
המוצעים ב- או
באמצעות
[כתובת האתר
של </span><span lang="EN" dir="LTR">Keilot.com</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>] או
יישום </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
הנייד ("<b>האתר</b>")
על ידי </span><span lang="EN" dir="LTR">Keilot.com
Ltd</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.
(כתובת: [כתובת </span><span lang="EN" dir="LTR">Keilot.com Ltd</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>. בישראל])
וחברות הבת
שלה (ככל שיש),
בהתאמה. </span><span lang="EN" dir="LTR">Keilot.com
Ltd</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.
וחברות הבת
שלה יכונו יחד
"</span><b><span lang="EN" dir="LTR">Keilot®</span></b><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>" "אנו"
או "שלנו", ו"<b>אתה</b>"
או "<b>משתמש</b>"
מתייחס אליך
כמשתמש באתר.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">אנא קרא
את תנאי
השימוש בעיון
לפני שתתחיל
להשתמש באתר.
על ידי שימוש
באתר, פתיחת
חשבון או לחיצה
על כפתור "אני
מסכים/ה" או
"קבל/י" תנאי שימוש
כאשר אפשרות
זו זמינה לך,
אתה מקבל ומסכים,
בשמך או בשם
המעסיק שלך או
כל ישות אחרת
(אם רלוונטי),
להיות כפוף
ומחויב לתנאי
שימוש אלה,
לתנאי התשלום
של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>,
הנמצאים [כאן]
("<b>תנאי תשלום</b>"),
לכללי הקהילה
של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>,
הנמצאים [כאן],
ולכל
סטנדרטים,
תנאים,
מדיניות, הנחיות
וגילויים
נוספים במוצר
(יחד, "<b>התנאים</b>"),
אשר משולבים
בזאת על ידי
הפניה. כמו כן,
אתה מאשר
שקראת והבנת
את מדיניות הפרטיות
שלנו, הנמצאת
[כאן]. אם אינך
מעוניין להסכים
לתנאים אלה או
למדיניות
הפרטיות, עליך
להימנע מגישה
או שימוש
באתר. לפרטים
נוספים לגבי
הפעילות
והשימוש באתר,
אנא עיין
במאמרים המיועדים
לכך בתוך
התנאים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">צוות
תמיכת
הלקוחות שלנו
זמין [שעות
פעילות, לדוגמה:
24/7] אם יש לך
שאלות כלשהן
בנוגע לאתר או
לתנאים. ניתן
ליצור קשר עם
צוות תמיכת
הלקוחות שלנו
באמצעות הגשת
בקשה [כאן].
למידע נוסף
אודות נקודות
יצירת הקשר
המיועדות
שלנו, ראה [כאן].</span></p>

<div class="MsoNormal" align="center" dir="RTL" style="text-align:center;direction:
rtl;unicode-bidi:embed"><span lang="EN" dir="LTR">

<hr size="2" width="100%" align="center">

</span></div>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><b><span lang="AR-SA"><span dir="RTL"></span>1.
הצהרות
ואחריות</span></b></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">אתר זה
מוצע וזמין
למשתמשים שהם
בני 18 לפחות ובגיל
חוקי לכריתת
חוזה מחייב.
אם גילך מתחת
ל-18 אך לפחות 13,
מותר לך
להשתמש באתר
רק באמצעות
חשבון בבעלות
הורה או
אפוטרופוס חוקי
ובאישורם
המתאים. אם
גילך מתחת ל-13,
אינך רשאי/ת
להשתמש באתר
או בשירותי </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">האתר
זמין רק
למשתמשים
שאינם כפופים
לסנקציות
כלכליות או
הגבלות סחר
שהוטלו על ידי
ארצות הברית,
האיחוד
האירופי או כל
תחום שיפוט
רלוונטי אחר.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">על ידי
שימוש באתר,
אתה מצהיר
ומתחייב כי
אתה עומד בכל
דרישות
הכשירות הנ"ל.
אם אינך עומד
בכל הדרישות
הללו, עליך
להימנע מגישה
או שימוש באתר.</span></p>

<div class="MsoNormal" align="center" dir="RTL" style="text-align:center;direction:
rtl;unicode-bidi:embed"><span lang="EN" dir="LTR">

<hr size="2" width="100%" align="center">

</span></div>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><b><span lang="AR-SA"><span dir="RTL"></span>2.
מונחים
עיקריים</span></b></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:36.0pt;
margin-bottom:0cm;margin-left:0cm;margin-bottom:.0001pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><b><span lang="AR-SA">קהילה/ות:</span></b><span lang="AR-SA"> קבוצת
משתמשים
שהתאגדה סביב
עניין, צורך
או זהות
משותפת, ואשר
במסגרתה
מתקיימת
הפעילות של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> בין ספקים
לצרכנים.
הקהילה בוחרת
את הספקים, והספקים
בוחרים את
הקהילות שבהן
יפעלו.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><b><span lang="AR-SA">צרכנים:</span></b><span lang="AR-SA"> משתמשים
רוכשים
שירותים ב-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><b><span lang="AR-SA">ספקים:</span></b><span lang="AR-SA"> משתמשים
המציעים
ומספקים
שירותים ב-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><b><span lang="AR-SA">הצעות
מותאמות
אישית:</span></b><span lang="AR-SA">
הצעות
בלעדיות שספק
יכול ליצור
בתגובה לדרישות
ספציפיות של
צרכן.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><b><span lang="AR-SA">שירות/ים:</span></b><span lang="AR-SA"> שירותים
המוצעים ב-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>,
לרבות
באמצעות הצעה
מותאמת אישית
או מודל שעות.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><b><span lang="AR-SA">דף
שירות:</span></b><span lang="AR-SA"> דף
וירטואלי שבו
הספק יכול
לתאר את
השירות ותנאיו,
והצרכן יכול
לרכוש את
השירות
וליצור הזמנה.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><b><span lang="AR-SA">הזמנה/ות:</span></b><span lang="AR-SA"> ההסכמים
הרשמיים בין
צרכן לספק,
לרבות הזמנות
דרך דף שירות,
הצעה מותאמת
אישית או מודל
שעות.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><b><span lang="AR-SA">דף
הזמנה:</span></b><span lang="AR-SA">
המקום שבו
צרכנים
וספקים
מתקשרים זה עם
זה בקשר
לשירות
שהוזמן.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><b><span lang="AR-SA">מערכת
ניהול עסק:</span></b><span lang="AR-SA">
הפונקציונליות
בתוך
הפלטפורמה
המאפשרת לספקים
לנהל הזמנות,
תשלומים,
שעות, ומלאי,
ולשמור על קשר
עם לקוחות.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><b><span lang="AR-SA">בלעדיות
קהילתית:</span></b><span lang="AR-SA">
רמת הבלעדיות
שספק מקבל
בתוך קהילה
מסוימת, המאפשרת
לו תכנון
ויציבות
עסקית.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:0cm;margin-right:36.0pt;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;text-indent:-18.0pt;
direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span dir="RTL"></span><b><span lang="AR-SA">פיטורים
קהילתיים:</span></b><span lang="AR-SA"> מנגנון
לטיפול
בספקים שאינם
עומדים
בסטנדרטים
הקהילתיים,
המאפשר
לקהילה
להפסיק את פעילותם
בפלטפורמה
במקרים של
שירות לקוי,
במקום הסתמכות
על ביקורות
פומביות.</span></p>

<div class="MsoNormal" align="center" dir="RTL" style="text-align:center;direction:
rtl;unicode-bidi:embed"><span lang="EN" dir="LTR">

<hr size="2" width="100%" align="center">

</span></div>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><b><span lang="AR-SA"><span dir="RTL"></span>3.
סקירה כללית
(תנאים
עיקריים, על
קצה המזלג)</span></b></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">רק
משתמשים
רשומים רשאים
לקנות ולמכור
ב-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>. בעת
הרשמה לחשבון,
אתה מסכים
לספק לנו מידע
מדויק, מלא
ועדכני אודות
העסק או פרטיך
האישיים,
ולעדכן פרטים
אלה לפי
הצורך, ללא
דיחוי בלתי
סביר. בנוסף,
אסור לך ליצור
חשבון למטרות
הונאה או
הטעיה. אתה
האחראי
הבלעדי לכל
פעילות בחשבונך
ולשמירה על
סודיות
ואבטחת
סיסמתך. איננו
אחראים לכל
מעשה או מחדל
שלך בקשר
לחשבונך.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">ספקים
קובעים את
תמחורם, לפי
שיקול דעתם
הבלעדי.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">צרכנים
משלמים ל-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
מראש כדי
ליצור הזמנה,
כפי שיפורט
בתנאי התשלום.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">ספקים
חייבים למלא
את הזמנותיהם,
ואינם רשאים
לבטל הזמנות
באופן קבוע או
ללא סיבה
מוצדקת. ביטול
הזמנות ישפיע
על המוניטין
של הספקים ועל
מעמדם.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">ספקים
זוכים לרמות
חשבון בהתבסס
על מדדי הביצועים
שלהם. תוכל
לקרוא עוד על
כך בסעיף
"רמות" להלן.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">משתמשים
אינם רשאים
להציע או לקבל
תשלומים בשיטה
אחרת מלבד
ביצוע הזמנה
דרך האתר.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">בעת
רכישה ב-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>,
צרכנים
מקבלים את כל
הזכויות עבור
העבודה שסופקה,
אלא אם צוין
אחרת על ידי
הספק בדף
השירות שלו או
אם הוסכם אחרת
בין הספק
לצרכן.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> היא
פלטפורמה
לשירותים
המוצעים על
ידי ספקים.
צרכנים
מאשרים כי הם
יתקשרו עם כל
הספקים כקבלנים
עצמאיים ולא
יפעילו שליטה
על אופן ביצוע
עבודתם, ולא
יספקו פיקוח
או הנחיות
לגבי האופן או
האמצעים שבהם
השירותים
מושלמים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> שומרת
לעצמה את
הזכות להשתמש
בכל עבודה
שסופקה
שהצרכן הסכים
לפרסם כחלק
מביקורת או
להפוך אותה
לפומבית בדרך
אחרת, למטרות
שיווק וקידום
של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> ו/או
למטרות אחרות
הרלוונטיות
לתפעול ולתפקוד
האתר.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">אנו
דואגים
לפרטיותך.
תוכל לקרוא את
מדיניות הפרטיות
שלנו [כאן].</span></p>

<div class="MsoNormal" align="center" dir="RTL" style="text-align:center;direction:
rtl;unicode-bidi:embed"><span lang="EN" dir="LTR">

<hr size="2" width="100%" align="center">

</span></div>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><b><span lang="AR-SA"><span dir="RTL"></span>4.
ספקים</span></b></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><b><span lang="AR-SA"><span dir="RTL"></span>4.1
יסודות</span></b></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">ספקים
יוצרים דפי
שירות ב-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> כדי
לאפשר
לצרכנים
לרכוש את
שירותיהם.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">ספקים
רשאים גם
להציע הצעות
מותאמות
אישית.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">למידע
אודות קבלת
תשלומים,
עמלות ומיסים,
עיין בתנאי
התשלום.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">דירוג
הספק מחושב
בהתבסס על
משוב שסופק על
ידי צרכנים.
דירוגים
גבוהים
מאפשרים
לספקים להשיג
רמות ספק
מתקדמות.
במקרים
מסוימים,
דירוגים
נמוכים
במיוחד
עשויים
להוביל
להשעיית חשבון
הספק (ראה
סעיף רמות
להלן) ו/או
לפיטורים קהילתיים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">ספקים
חייבים
להחזיק
בפוליסת
ביטוח אחריות כללית
עם כיסוי
מספיק לכיסוי
כל הסיכונים
הקשורים
לביצוע
שירותיהם.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">אם אתה
מצהיר כי אתה
מוכר ב-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
למטרות
הקשורות
לעבודתך או
למקצועך
העיקרי, תיחשב
כ"ספק עסקי"
והתנאים
הנוספים
הבאים יחולו
עליך: (</span><span lang="EN" dir="LTR">i</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>) בעת
יצירת שירות,
או לבקשתנו,
ספקים עסקיים
יידרשו להגיש
את המידע
והמסמכים
הבאים ל-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>: (א)
שם, כתובת,
מספר טלפון
וכתובת דוא"ל;
(ב) עותק מסמך
זיהוי (כגון
תעודת זהות,
דרכון) או
זיהוי אלקטרוני
אחר כפי
שיידרש על
ידינו; (ג) פרטי
תשלום; (ד) מספר
רישום עסק או
אמצעי זיהוי
מקביל והמרשם
המסחרי שבו
הספק העסקי
רשום (אם
רלוונטי); (ה)
הצהרה עצמית
של הספק העסקי
המתחייבת להציע
רק מוצרים או
שירותים
העומדים
בתקנות
האיחוד
האירופי הרלוונטיות;
ו-(ו) לבקשתנו,
מסמכים
מתאימים
נוספים
המוכיחים את
המידע שנמסר. (</span><span lang="EN" dir="LTR">ii</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>)
אם ספק עסקי
לא יספק מידע
ומסמכים אלה
בתוך מועד
סביר, </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
רשאית להגביל
או להשעות את
החשבון.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><b><span lang="AR-SA"><span dir="RTL"></span>4.2
שירותים</span></b></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">ספקים
רשאים לפרסם
כמות נבחרת של
שירותים פעילים
בהתבסס על
סטטוס הרמה
שלהם, כפי
שיפורט [כאן].</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">שירותים
שנוצרו ב-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
הם <b>תוכן
שנוצר על ידי
משתמשים</b></span><span dir="LTR"></span><span lang="EN" dir="LTR"><span dir="LTR"></span>.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">שירותים
ו/או משתמשים
עשויים להיות
מוסרים על ידי
</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> מהאתר
עקב הפרות של
התנאים, אשר
עשויות לכלול
(אך אינן
מוגבלות ל)
ההפרות ו/או
החומרים הבאים:</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:36.0pt;
margin-bottom:0cm;margin-left:0cm;margin-bottom:.0001pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">שירותים
בלתי חוקיים
או הונאה.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">הפרת
זכויות
יוצרים, הפרת
סימן מסחר,
והפרה של תנאי
שירות של צד
שלישי
המדווחים
באמצעות מדיניות
תביעות קניין
רוחני שלנו,
הנמצאת [כאן].</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">שירותים
בעלי אופי
מיני,
פורנוגרפיים,
בלתי הולמים/מגונים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">העתקות
מכוונות של
שירותים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">דואר
זבל, חסרי
משמעות,
שירותים
אלימים או מטעים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">שירותים
המטעים
צרכנים או
אחרים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">מכירה
חוזרת של
סחורות
מוסדרות.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">הצעה
להכין עבודות
אקדמיות בשם
צרכנים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">שירותים
או מסירות
באיכות ירודה.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:0cm;margin-right:36.0pt;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;text-indent:-18.0pt;
direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span dir="RTL"></span><span lang="AR-SA">קידום
</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> ו/או
שירותי </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
באמצעות
פעילויות
האסורות על פי
כל חוק, תקנה
ו/או תנאי
שירות של צד
שלישי, וכן
באמצעות כל פעילות
שיווקית
המשפיעה לרעה
על יחסינו עם
המשתמשים או
השותפים שלנו.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">שירותים
שיוסרו עקב
הפרות
הנזכרות לעיל,
עלולים
להוביל
להשעיית
חשבון הספק
ו/או לפיטורים
קהילתיים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">שירותים
שהוסרו
לצמיתות עקב
הפרות אינם
זכאים לשחזור
או עריכה.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">שירותים
עשויים להיות
מוסרים
מהרישומים שלנו
עקב הפרות של
התנאים שלנו,
ביצועים
ירודים, ו/או
התנהגות בלתי
הולמת של
משתמש.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">שירותים
עשויים לכלול
כתובות </span><span lang="EN" dir="LTR">URL</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
לאתרים
בתבניות </span><span lang="EN" dir="LTR">URL</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
מאושרות
הכלולות
בתיאור
השירות
ובתיבת הדרישות.
שירותים
המכילים
אתרים
המקדמים תוכן
המפר את תנאי </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> יוסרו.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">שירותים
נדרשים לכלול
תמונת שירות
מתאימה הקשורה
לשירות המוצע.
ספקים חייבים
לספק את אותה
איכות שירות
כפי שמוצג
בתמונות
השירות שלהם.
מסירות
חוזרות שאינן
תואמות את
האיכות
המוצגת בתמונות
השירות
עלולות
להוביל
לאובדן רמת הספק
של חשבון הספק
או להשבתה
לצמיתות.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">הצהרות
בדף השירות
המערערות או
עוקפות תנאים
אלה אסורות.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><b><span lang="AR-SA"><span dir="RTL"></span>4.3
רמות</span></b></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">מערכת
הרמות שלנו
מעצימה את
הספקים
באמצעות מדדים
המדגימים את
התקדמותם. ככל
שהספקים צוברים
יותר ניסיון
בפלטפורמה
ומתקדמים
לרמות גבוהות
יותר, הם יהיו
זכאים להטבות
וכלים חדשים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">ספקים ב-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> יכולים
לצבור רמות
חשבון בהתבסס
על פעילותם ומדדי
הביצועים
שלהם. לפרטים
אודות
קריטריוני
הרמה ומדדי
הביצועים
הרלוונטיים
ניתן למצוא
[כאן].</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> רשאית
לעדכן את
קריטריוני
הרמה ואת
ההטבות והכלים
לכל רמה מעת
לעת.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">הפרות של
תנאים אלה
עלולות
להוביל
להקפאת חשבונך
מקידום
במערכת הרמות,
הוצאת חשבונך
מהשתתפות
במערכת הרמות
ו/או השפעה על
זכאותך להטבות
וכלים
מסוימים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><b><span lang="AR-SA"><span dir="RTL"></span>4.4
תכונות ספק</span></b></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">לספקים ב-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> יש גישה
למספר תכונות
בלעדיות
המסייעות להתאים
אישית את אופן
הצעת
השירותים
שלהם.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><b><span lang="AR-SA">הצעה
מותאמת אישית</span></b><span lang="AR-SA"> ספקים
יכולים לשלוח
הצעות
מותאמות
אישית העונות
לדרישות
ספציפיות של
צרכן. הצעות
מותאמות
אישית
מוגדרות על
ידי הספק עם
תיאור מדויק של
השירות, המחיר
וזמן האספקה
המשוער. הצעות
מותאמות
אישית נשלחות
מדף השיחה.
שירותים המסופקים
באמצעות
הצעות
מותאמות
אישית אינם רשאים
להפר את תנאי </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><b><span lang="AR-SA">אבני דרך
לפרויקט</span></b><span lang="AR-SA">
שירותים
והצעות
מותאמות
אישית מעל
[סכום מינימלי,
לדוגמה: $100]
עשויים לכלול
עד [מספר אבני
דרך, לדוגמה:
שישה] אבני
דרך לפרויקט.
הסכום המינימלי
לכל אבן דרך
הוא [סכום
מינימלי,
לדוגמה: $50] והפרויקט
צריך לכלול
לפחות שתי
אבני דרך. כל
אבן דרך
משולמת
ומסופקת
בנפרד בהתאם
לתיאור ולוחות
הזמנים של כל
שירות או הצעה
מותאמת אישית.
לאחר שאבן דרך
נמסרת
ומסומנת
כהושלמה,
צרכנים
יכולים לבחור
להמשיך עם
ההזמנה ולשלם
עבור אבן הדרך
הבאה, או
לעצור את
ההזמנה. אם
הצרכן לא ישלם
עבור אבן הדרך
הבאה בתוך 10
ימים ממועד קבלת
אבני דרך
קודמות,
ההזמנה תחת
אבני הדרך הבאות
לא תתחיל. אבן
דרך תסומן
אוטומטית
כהושלמה אם לא
הוגשו קבלה או
בקשה לשינוי
בתוך 8 ימים ממועד
סימונה
כ"נמסר", אולם
במקרה כזה <b>כל
אבני הדרך
הבאות לא
יתחילו</b></span><span dir="LTR"></span><span lang="EN" dir="LTR"><span dir="LTR"></span>.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><b><span lang="AR-SA">מנוי
לשירות</span></b><span lang="AR-SA">
ספקים זכאים
רשאים להציע
לצרכנים מנוי
לתקופה קבועה
עבור שירות
ספציפי ("<b>מנוי
לשירות</b>").
במהלך תקופת
המנוי לשירות,
הספק יספק
הזמנה אחת של
אותו שירות על
בסיס חוזר,
כפי שהוסכם בין
הספק לצרכן.
צרכנים רשאים
לבטל הזמנות
עתידיות
במסגרת המנוי
לשירות לפני
ביצוע התשלום
עבור הזמנות
עתידיות כאלה.
במקרה כזה,
ההזמנות
במסגרת המנוי
לשירות
יבוטלו, לפי
העניין. לאחר
ביצוע התשלום,
תחול מדיניות
ביטול ההזמנות
של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> על פי
תנאי התשלום.
ספקים רשאים
לבטל את המנוי
לשירות עד 10
ימים לפני
ההזמנה
הרצופה הבאה.
אחרת, תחול
מדיניות
ביטול
ההזמנות של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> על פי תנאי
התשלום.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><b><span lang="AR-SA"><span dir="RTL"></span>4.5
משלוח חפצים
פיזיים</span></b></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">חלק
מהשירותים ב-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> נמסרים
פיזית (אמנות
ומלאכת יד,
פריטי אספנות
וכו'). עבור
סוגי שירותים
אלה, ספקים
רשאים להחליט
להגדיר גורם
תמחור משלוח.
הדברים הבאים
חייבים לחול
במקרה שספק
וצרכן הסכימו
על משלוח
חפצים פיזיים:</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:36.0pt;
margin-bottom:0cm;margin-left:0cm;margin-bottom:.0001pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">שירותים
הכוללים גורם
תמחור משלוח
חייבים לכלול
פריטים
פיזיים
הנשלחים
לצרכנים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">עלויות
המשלוח
שנוספו
לשירות
מתייחסות רק לעלות
שספקים
דורשים
למשלוח
פריטים
פיזיים לצרכנים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><b><span lang="AR-SA">חשוב:</span></b><span lang="AR-SA"> צרכנים
הרוכשים
שירותים
הדורשים
משלוח פיזי,
יתבקשו לספק
כתובת למשלוח.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">ספקים
אחראים לכל
סידורי
המשלוח ברגע
שהצרכן מספק
את כתובת
המשלוח.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> אינה
מטפלת או
מבטיחה משלוח,
מעקב, איכות
ומצב של
פריטים או
מסירתם, ולא
תהיה אחראית
לכל נזק או
בעיות אחרות
הנובעות
ממשלוח.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:0cm;margin-right:36.0pt;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;text-indent:-18.0pt;
direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span dir="RTL"></span><span lang="AR-SA">מספר
מעקב הוא דרך
מצוינת למנוע
מחלוקות הקשורות
למשלוח. אנו
דורשים הזנת
מספר המעקב אם
זמין בדף
ההזמנה בעת
מסירת עבודתך.</span></p>

<div class="MsoNormal" align="center" dir="RTL" style="text-align:center;direction:
rtl;unicode-bidi:embed"><span lang="EN" dir="LTR">

<hr size="2" width="100%" align="center">

</span></div>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><b><span lang="AR-SA"><span dir="RTL"></span>5.
צרכנים</span></b></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><b><span lang="AR-SA"><span dir="RTL"></span>5.1
יסודות</span></b></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">אינך
רשאי להציע תשלומים
ישירים
לספקים
באמצעות
מערכות תשלום
מחוץ
לפלטפורמת </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> שומרת
לעצמה את
הזכות להשתמש
בכל עבודה
שסופקה
שהצרכן הסכים
לפרסם כחלק
מביקורת או
להפוך אותה
לפומבית בדרך
אחרת, למטרות
שיווק וקידום
של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> ו/או
למטרות אחרות
הרלוונטיות
לתפעול ולתפקוד
האתר.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">שירותים
ותוכן שנוצר
על ידי ספק
לפי דרישת צרכן
חייבים לעמוד
בכללי הקהילה
של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">צרכנים
אחראים
בלעדית לסקור
כל מסירה
פוטנציאלית
שנוצרה על ידי
ספק ותוכן
ותקצירים אחרים
שנוצרו,
ולוודא שהם
מתאימים
לצרכיהם ועומדים
בכללי הקהילה
של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">בעת
ביצוע הזמנה
בפלטפורמת </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>, אתה רשאי
להשתמש רק
בכספים
שהושגו
ממקורות חוקיים
ואינם קשורים,
במישרין או
בעקיפין, לפעילויות
בלתי חוקיות
או הונאה.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><b><span lang="AR-SA"><span dir="RTL"></span>5.2
רכישה</span></b></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">אנא עיין
בתנאי התשלום
לביצוע
תשלומים דרך האתר
וללימוד
אודות עמלות
ומיסים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">אינך
רשאי להציע
לספקים לשלם,
או לבצע תשלום
באמצעות כל
שיטה אחרת
מלבד דרך אתר </span><span lang="EN" dir="LTR">Keilot.com</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>. במקרה
שהתבקשת
להשתמש בשיטת
תשלום חלופית,
אנא דווח על
כך מיד לתמיכת
הלקוחות [כאן].</span></p>

<div class="MsoNormal" align="center" dir="RTL" style="text-align:center;direction:
rtl;unicode-bidi:embed"><span lang="EN" dir="LTR">

<hr size="2" width="100%" align="center">

</span></div>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><b><span lang="AR-SA"><span dir="RTL"></span>6.
הזמנות</span></b></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><b><span lang="AR-SA"><span dir="RTL"></span>6.1
יסודות</span></b></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">לאחר
אישור התשלום,
הזמנתך
תיווצר.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">הזמנה
מסומנת
כ"הושלמה"
לאחר שסומנה
כ"נמסרה"
ולאחר מכן
התקבלה על ידי
צרכן. הזמנה
תסומן אוטומטית
כ"הושלמה" אם
לא התקבלה ולא
הוגשה בקשה
לשינוי בתוך 3
ימים לאחר
שההזמנה
סומנה כ"נמסרה".
הצרכן רשאי
להאריך תקופה
זו בעד 5 ימים
נוספים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">אבן דרך
(בהזמנה עם
אבני דרך)
מסומנת
כ"הושלמה"
לאחר שהיא
נמסרה על ידי
הספק ולאחר
מכן התקבלה על
ידי הצרכן.
אבן דרך תסומן
אוטומטית
כ"הושלמה" אם
לא הוגשו קבלה
או בקשה
לשינוי בתוך 8 ימים
לאחר סימונה
כ"נמסרה",
אולם במקרה
כזה ההזמנה <b>תיעצר</b>
וכל אבני הדרך
הבאות לא
יתחילו. לאחר
שאבן דרך
נמסרת
ומתקבלת,
צרכנים
יכולים לבחור
להמשיך עם
ההזמנה ולשלם
עבור אבן הדרך
הבאה, או לעצור
את ההזמנה. אם
הצרכן לא ישלם
עבור אבן הדרך
הבאה בתוך 10
ימים ממועד
קבלת אבני דרך
קודמות, ההזמנה
תחת אבני הדרך
הבאות לא
תתחיל. לידיעתך,
אם תבחר לעצור
אבני דרך
עתידיות, אבן
הדרך הנוכחית
שהוזמנה לא
תבוטל.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">צרכנים
רשאים לרכוש
מנוי לשירות,
אם זמין בדף השירות
של הספק.
במהלך תקופת
המנוי לשירות,
הזמנה חדשה של
אותו שירות
תיווצר
אוטומטית על בסיס
חוזר, כפי
שהוסכם בין
הספק לצרכן.
על ידי רכישת
מנוי לשירות,
אתה מאשר לנו
לחייב אותך אוטומטית
עבור כל הזמנה
במסגרת המנוי
לשירות מיתרת
ה-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> שלך או
משיטת תשלום
שמורה, לפי
העניין. אם
אין לך יתרת </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> או שיטת
תשלום שמורה,
תתבקש לאשר את
התשלום לפני
ההזמנה הבאה.
במקרה שתשלום
לא יעובד או
יבוצע על ידי
הצרכן, מכל
סיבה אחרת,
ההזמנות במסגרת
המנוי לשירות
יבוטלו. הצרכן
רשאי גם לבטל הזמנות
עתידיות
במסגרת המנוי
לשירות לפני
ביצוע התשלום
עבור הזמנות
עתידיות כאלה.
לאחר ביצוע
התשלום, תחול
מדיניות
ביטול
ההזמנות של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> על פי תנאי
התשלום.
לידיעתך,
ספקים יכולים
לבטל הזמנות
עתידיות
במסגרת המנוי
לשירות 10 ימים
לפני ההזמנה
הרצופה הבאה.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">שירותים
מסוימים
המציעים
שירותים
מקומיים עשויים
לדרוש
מצרכנים
וספקים
להיפגש באופן אישי
על מנת שהספק
יבצע את
השירות.
במקרים כאלה,
המשתמשים
צריכים לציין
כי </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> אינה
מבטיחה את
ההתנהגות,
ההתנהלות,
הבטיחות,
ההתאמה או
היכולת של
צרכנים או
ספקים. גם צרכנים
וגם ספקים
מסכימים כי
הסיכון המלא
הנובע מפגישתם
ו/או שימושם
או ביצועם של
שירותים מקומיים
נשאר אך ורק
עליהם, ול-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
אין כל אחריות
או חבות
הקשורה
לשירותים
מקומיים
כלשהם
הניתנים על
ידי הספקים.
במקרה שהשירות
מבוצע במתחם
הצרכנים,
מומלץ
לצרכנים לשמור
על פוליסות
ביטוח
מתאימות
לכיסוי
אחריותם
כבעלי המתחם.
תנאי </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
נשארים
ישימים
להזמנות
המבוצעות
מחוץ לפלטפורמה
(לרבות, בין
היתר, ההגבלות
שלהלן על שימוש
בלתי חוקי,
התנהגות ושפה
בלתי הולמת,
ושימוש לרעה
ממוקד).</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><b><span lang="AR-SA"><span dir="RTL"></span>6.2
טיפול
בהזמנות</span></b></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">כאשר
צרכן מבצע
הזמנה, הספק
מקבל הודעה
בדוא"ל וכן
התראות באתר
בעת כניסה
לחשבון.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">ספקים
נדרשים לעמוד
בזמן האספקה
שציינו בעת יצירת
השירותים
שלהם או הצעות
מותאמות אישית.
אי עמידה בכך
תאפשר לצרכן
לבטל את
ההזמנה כאשר
הזמנה מסומנת
כמאוחרת
ועלולה לפגוע
ברמת הספק.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">ספקים
חייבים לשלוח
קבצים
שהושלמו ו/או
הוכחת עבודה
בעת סימון
ההזמנה
כ"נמסרה".</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">כפתור
"מסירת
עבודה" אינו
רשאי להיות
מנוצל לרעה על
ידי ספקים כדי
לעקוף את
הנחיות ההזמנה
המתוארות
בתנאים אלה.
שימוש בכפתור
"מסירת עבודה"
כאשר הזמנה לא
מולאה עלול
לגרום לביטול
הזמנה זו לאחר
בדיקה, להשפיע
על דירוג הספק
ולגרום
לאזהרה לספק.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">משתמשים
אחראים לסרוק
את כל הקבצים
שהועברו לווירוסים
ותוכנות
זדוניות. </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
לא תישא
באחריות לכל
נזק שעלול
להתרחש עקב שימוש
באתר, שימוש
בתוכן או
קבצים
שהועברו.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">צרכנים
רשאים להשתמש
בתכונת "בקשת
תיקונים"
הנמצאת בדף
ההזמנה כאשר
הזמנה מסומנת
כ"נמסרה" אם
החומרים
שנמסרו אינם
תואמים את
תיאור הספק
בדף השירות
שלו או שאינם
תואמים את הדרישות
שנשלחו לספק
בתחילת תהליך
ההזמנה.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> שומרת
לעצמה את
הזכות לסמן
הזמנות
כ"הושלמו"
לאחר בקשת
תיקון במקרים
בהם צרכנים לא
היו רספונסיביים
עם הספקים
שלהם או אם
אנו מזהים שימוש
לרעה במערכת
ההזמנות של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><b><span lang="AR-SA"><span dir="RTL"></span>6.3
משוב
ופיטורים
קהילתיים</span></b></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">משוב
שסופק על ידי
צרכנים הוא
חלק חיוני
ממערכת
הדירוג של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.
למידע נוסף על
מערכת המשוב
של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>, עיין
[כאן].</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">משוב לא
יוסר אלא אם
יש הפרות
ברורות של
התנאים שלנו.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">כדי
למנוע כל
שימוש לרעה
במערכת המשוב
שלנו, כל
המשובים
חייבים להגיע מהזמנות
לגיטימיות
וכשרות, כפי
שיפורט [כאן]. רכישות
שסודרו, שנקבע
כי הן משפרות
באופן מלאכותי
את דירוגי
הספק, או
שמטרתן
להתעלל באתר, עלולות
לגרום להשעיה
קבועה של כל
החשבונות הקשורים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">אסור
לעכב את מסירת
השירותים,
הקבצים או
המידע
הנדרשים
להשלמת
השירות של
הספק מתוך
כוונה להשיג
משוב חיובי או
שירותים
נוספים. ספקים
אינם רשאים
לבקש הסרת
משובים
מצרכניהם
באמצעות
ביטולים
הדדיים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">לאחר שגם
הספק וגם
הצרכן השלימו
את המשוב שלהם,
או שחלפה
תקופת המשוב
הרלוונטית, כל
המשובים
שפורסמו
הופכים
לציבוריים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">דוגמאות
עבודה
מתווספות
לנכסי ספק ב-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> אם הצרכן
בוחר לפרסם את
המסירה בעת
מתן משוב ציבורי.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><b><span lang="AR-SA">מנגנון
פיטורים
קהילתיים:</span></b><span lang="AR-SA"> במקרים של
שירות לקוי
שאינו מטופל
או חוזר על
עצמו, </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
תאפשר לקהילה
לדון וליישם
מנגנון
"פיטורים קהילתיים"
שיוביל
להפסקת
פעילות הספק
באותה קהילה
או בפלטפורמה
כולה, בהתאם
לכללי הקהילה
ולמדיניות </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>. מנגנון זה
נועד להבטיח
את איכות
השירותים הניתנים
בקהילה ולשמר
את אמון
המשתמשים, ללא
צורך
בהסתמכות
בלעדית על
ביקורות
פומביות.</span></p>

<div class="MsoNormal" align="center" dir="RTL" style="text-align:center;direction:
rtl;unicode-bidi:embed"><span lang="EN" dir="LTR">

<hr size="2" width="100%" align="center">

</span></div>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><b><span lang="EN" dir="LTR">7</span></b><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>. תוכן
שנוצר על ידי
משתמשים (</span><span lang="EN" dir="LTR">User Generated Content - UGC</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>)</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>7.1
אחריות
ועמידה בתוכן.
ספקים חייבים
לוודא שכל
תוכן וחומרים
המשמשים
להצעת
שירותיהם הם
עבודתם
המקורית, אינם
מפרים זכויות
צד שלישי
ועומדים בכל
תנאי </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>,
לרבות כפי
שיפורט בסעיף
10 להלן (הנקרא
"תוכן שנוצר
על ידי
משתמשים")
וכללי הקהילה
של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>. ספקים
אחראים
בלעדית לכל
תוכן וחומרים
המשמשים
להצעת
שירותיהם, וכן
לכל תוצר או
שירות המסופקים
על בסיס התוכן
שלהם.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>7.2
בעלות על קלט (</span><span lang="EN" dir="LTR">Input</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>). ככל שהדבר
מותר על פי
החוקים החלים,
ובתנאי שלספקים
עומדות
הזכויות
הנדרשות,
ספקים שומרים
על זכויותיהם
בתוכן המשמש
ליצירת
השירותים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>7.3
בעלות על
מסירה. ככל
שהדבר מותר על
פי החוקים החלים
ובכפוף
לתשלום מלא,
צרכנים הם
הבעלים של
המסירה
(העבודה
שהושלמה).</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>7.4
דמיון בתוכן
ואי-בלעדיות.
ספקים ו-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
אינם מבטיחים
כי שירותים
מסוימים
שסופקו יהיו
ייחודיים או
בלעדיים,
במיוחד אם
השירותים דומים
או משתמשים
בשיטות
נפוצות.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>7.5
שימוש במסירה
על ידי ספק. אם
צרכנים
מאפשרים לספקים
להציג בפומבי
את המסירה
(כחלק מתיק עבודות
או ביקורת),
ספקים רשאים
להשתמש בה
לצורך הצגת
יכולותיהם
בתוך
פלטפורמת </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>7.6
שימוש במסירה
על ידי צרכן.
צרכנים
אחראים לוודא
ששימושם
במסירה אינו
מפר זכויות של
צד שלישי
כלשהו ועומד
בתנאים אלה
ובחוקים
החלים, לרבות
זכויות קניין
רוחני כגון
זכויות יוצרים
או סימני
מסחר.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>7.7
מגבלות על
תוכן שנוצר. </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> אינה
מתחייבת
לדיוק,
אמינות,
ייחודיות או
התאמה למטרות
ספציפיות של
שירותים או כל
תוכן אחר
שנוצר. עליך
לא להסתמך על
שירותים אלה
או על כל תוכן
שנוצר כעל
מקור יחיד
לאמת. עליך
להעריך אותו
לצורך דיוק
והתאמה למקרה
השימוש שלך, לרבות
שימוש בבדיקה
אנושית לפי
הצורך.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>8.
התנהלות
והגנת
משתמשים</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> מאפשרת
לאנשים ברחבי
העולם ליצור,
לשתף, למכור
ולרכוש כמעט
כל שירות שהם
צריכים בערך
ללא תחרות.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> שומרת
על סביבה
ידידותית,
קהילתית
ומקצועית. משתמשים
צריכים לשמור
על רוח זו תוך
כדי השתתפות
בכל פעילות או
הרחבות של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.
סעיף זה
מתייחס
להתנהגות
הצפויה
ממשתמשים בעת
אינטראקציה
זה עם זה ב-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">כדי
לדווח על הפרה
של התנאים
שלנו, התנהגות
בלתי הולמת של
משתמשים, או
פניות בנוגע
לחשבונך, אנא
צור קשר עם
צוות תמיכת
הלקוחות שלנו
[כאן].</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>8.1
יסודות</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">אסור
לבקש או לספק
כתובות דוא"ל,
יישומי הודעות
צד שלישי,
מספרי טלפון
או כל פרטי
קשר אישיים
אחרים
לתקשורת מחוץ
ל-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> במטרה
לעקוף או לנצל
לרעה את מערכת
ההודעות של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> או את
פלטפורמת </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">כל החלפה
הכרחית של
מידע אישי
הנדרשת להמשך
שירות עשויה
להתבצע בתוך
דף ההזמנה.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> אינה
מספקת כל
ערובה לרמת
השירות
המוצעת על ידי
ספקים
לצרכנים. אתה
רשאי להשתמש
בכלי יישוב
סכסוכים
העומדים
לרשותך בדף
ההזמנה.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> אינה
מספקת הגנה
למשתמשים
המקיימים
אינטראקציה
מחוץ לאתר.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">כל
חילופי המידע
והקבצים
חייבים
להתבצע אך ורק
באתר.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">שפה גסה,
פוגענית או
בלתי הולמת,
והודעות אלימות
או מאיימות לא
יסבלו
ועלולות
לגרום לאזהרה
לחשבון או
להשעיה/הסרה
של חשבונך.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">אתה
מתחייב לא
להפלות כל
משתמש אחר על
בסיס מגדר,
גזע, גיל,
השתייכות
דתית, נטייה
מינית או
אחרת, ואתה
מאשר כי אפליה
כזו עלולה
לגרום
להשעיה/הסרה
של חשבונך.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">משתמשים
אינם רשאים
להגיש הצעות
או לשדל צדדים
שהוצגו
באמצעות </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
להתקשר בחוזה,
להתקשר עמם,
או לשלם מחוץ
ל-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>8.2
הזמנות</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">משתמשים
בעלי כוונה
להשמיץ ספקים
מתחרים על ידי
הזמנה
משירותים
מתחרים יוסרו
מהם הביקורות
או יינקטו
פעולות
נוספות
הקשורות
לסטטוס
החשבון אשר
ייקבעו על ידי
צוות האמון
והבטיחות
שלנו.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">משתמשים
צריכים
להימנע
משליחת דואר
זבל או שדלנות
לצרכנים או
ספקים קודמים
לרדוף אחר הסרה/שינוי
ביקורות או
ביטול הזמנות
שאינן עולות
בקנה אחד עם
מדיניות
ביטול הזמנות
או משוב.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>8.3
דפי שירות
וספקים</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">ספקים
מתחייבים כי
כל תוכן הכלול
בשירותים שלהם,
בדף השירות
ובדף הספק,
הוא עבודה
מקורית שנוצרה
על ידי הספק
ואינה מפרה
זכויות צד שלישי
כלשהן, לרבות,
ללא הגבלה,
זכויות
יוצרים, סימני
מסחר או סימני
שירות. במקרה
שמוסיפים מוזיקה
או קטעי מדיה
ממאגרים
לשירות, לדף
השירות או לדף
הספק, ספקים
מצהירים
ומתחייבים כי
יש להם רישיון
תקף לשימוש
במוזיקה ו/או
בקטעים אלה
ולכלול אותם
בשירותים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">משתמשים
רשאים לדווח
על שירותים
שעלולים להפר
את תנאי </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
בהתבסס על
דמיון משוכפל
של השירות
המדווח לשירותים
קיימים
(שירותים
מועתקים)
באמצעות מערכת
הדיווח שלנו
או לתמיכת
הלקוחות.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> תגיב
להודעות
ברורות
ומלאות על
הפרת זכויות יוצרים
או סימני מסחר
לכאורה. כדי
ללמוד כיצד לדווח
על הפרות
קניין רוחני
לחץ [כאן]. אם
אתה מדווח על
הפרת זכויות
יוצרים או
סימן מסחר,
עיין
במדיניות
תביעות קניין
רוחני
המיועדת לכך שלנו
[כאן].</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>8.4
דיווח על
הפרות</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">אם נתקלת
בתוכן כלשהו
שעלול להפר את
התנאים שלנו
ו/או את כללי
הקהילה שלנו,
עליך לדווח
לנו על כך
באמצעות
הערוצים
המתאימים
שנוצרו לטיפול
בנושאים אלה,
כפי שמתואר
בתנאים שלנו.
כל המקרים
נבדקים על ידי
צוות האמון
והבטיחות שלנו.
החלטתנו, בין
היתר, עשויה
להסתמך על
המידע שסיפקת
לנו. כדי להגן
על פרטיות
הפרט, תוצאות
החקירה אינן
משותפות. תוכל
לעיין
במדיניות הפרטיות
שלנו למידע
נוסף. כל
שימוש לרעה
במערכת
הדיווח שלנו,
כפי שיפורט
[כאן], עלול
לגרום להגבלה
או השעיה
קבועה של
החשבונות
הקשורים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>8.5
הפרות</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">משתמשים
עלולים לקבל
אזהרה
לחשבונם בגין
הפרות של
התנאים שלנו
או כל התנהגות
בלתי הולמת של
משתמש שדווחה
לצוות האמון
והבטיחות
שלנו. אזהרה
תישלח לכתובת
הדוא"ל של
המשתמש ותוצג עבור
משתמש כזה
באתר. אזהרות
אינן מגבילות
את פעילות
החשבון, אך
יכולות לגרום
להקפאת חשבונך
מקידום
במערכת הרמות,
הוצאת חשבונך
מהשתתפות
במערכת הרמות,
השפעה על
זכאותך למכור
בפלטפורמה, או
להטבות וכלים
מסוימים, הסרת
השירותים שלך
מהרישומים
שלנו או
להוביל
להשבתת חשבונך
לצמיתות.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">אם נקטנו
פעולה נגד
חשבון משתמש
או שירות/ים, בגין
הפרה של
התנאים שלנו,
אנו נשלח
למשתמש דוא"ל
המסביר את
הסיבות
והבסיס
לפעולות אלה,
וכן את
אפשרויותיהם
לגבי בדיקה
נוספת. למידע
נוסף, עיין
בסעיף הודעות
וערעורים
שלנו.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">שימוש
אסור</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:36.0pt;
margin-bottom:0cm;margin-left:0cm;margin-bottom:.0001pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">שירותי
מבוגרים
ופורנוגרפיה -
</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> אינה
מאפשרת כל
חילופי
חומרים
ושירותים בעלי
אופי מיני או
פורנוגרפי.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">התנהגות
ושפה בלתי
הולמת -
התקשורת ב-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
צריכה להיות
ידידותית,
בונה
ומקצועית. </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
מגנה בריונות,
הטרדה ודברי
שטנה כלפי
אחרים. אנו מאפשרים
למשתמשים
אמצעי שבו
מתבצעות
חילופי
הודעות בין
יחידים, מערכת
לדירוג
הזמנות, ולהשתתף
בפלטפורמות
גדולות יותר
כגון פורום הקהילה
שלנו ודפי
המדיה
החברתית.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">פישינג
ודואר זבל -
אבטחת החברים
היא בראש סדר
העדיפויות. כל
ניסיון לפרסם
או לשלוח תוכן
זדוני במטרה
לפגוע
בחשבונו של
חבר אחר או
בסביבת המחשב
שלו אסור
בהחלט. אנא
כבד את פרטיות
חברינו על ידי
אי יצירת קשר
איתם עם
הצעות, שאלות,
הצעות או כל
דבר שאינו
קשור ישירות
לשירותיהם או
הזמנותיהם.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">פרטיות
וזהות - אינך
רשאי לפרסם או
לפרסם מידע
פרטי וסודי של
אנשים אחרים.
כל חילופי
מידע אישי
הנדרשים
להשלמת שירות
חייבים
להינתן בדף
ההזמנה. ספקים
מאשרים עוד כי
כל מידע שהם
מקבלים
מהצרכן, שאינו
ברשות הציבור,
לא ישמש לשום
מטרה אחרת
מלבד מסירת
העבודה לצרכן.
כל משתמש
שיקיים
אינטראקציה
ויתקשר מחוץ
ל-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> לא יהיה
מוגן על ידי
תנאי השירות
שלנו.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">פרופיל </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> אותנטי -
אינך רשאי
ליצור זהות
כוזבת ב-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>,
להציג באופן
שקרי את
זהותך, ליצור
פרופיל </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
עבור מישהו
אחר מלבד עצמך
(אדם אמיתי), או
להשתמש או
לנסות להשתמש
בחשבון או
במידע של
משתמש אחר;
פרטי הפרופיל
שלך, לרבות
התיאור,
הכישורים,
המיקום וכו',
חייבים להיות
מדויקים
ושלמים ואינם
רשאים להיות
מטעים, בלתי
חוקיים, פוגעניים
או מזיקים
בדרך אחרת. </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> שומרת
לעצמה את
הזכות לדרוש
ממשתמשים
לעבור תהליך
אימות על מנת
להשתמש באתר
(בין אם באמצעות
תעודת זהות,
טלפון, מצלמה,
תמצית רישום,
מסמכים וכו').</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">טענות
קניין רוחני - </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> תגיב
להודעות
ברורות
ומלאות על
הפרת זכויות יוצרים
או סימן מסחר
לכאורה, ו/או
הפרה של תנאי
שירות של צד
שלישי. נוהלי
תביעות
הקניין הרוחני
שלנו ניתנים
לבדיקה [כאן].</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:0cm;margin-right:36.0pt;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;text-indent:-18.0pt;
direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span dir="RTL"></span><span lang="AR-SA">הונאה
/ שימוש בלתי
חוקי - אינך
רשאי להשתמש
ב-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> למטרות
בלתי חוקיות
כלשהן או
לביצוע
פעילויות
בלתי חוקיות,
לרבות עקיפת
סנקציות
כלכליות או
הגבלות סחר
שהוטלו על ידי
ארצות הברית,
האיחוד
האירופי או כל
תחום שיפוט
רלוונטי אחר.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">שימוש
לרעה ודואר
זבל</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:36.0pt;
margin-bottom:0cm;margin-left:0cm;margin-bottom:.0001pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">חשבונות
מרובים - כדי
למנוע הונאה
ושימוש לרעה,
משתמשים
מוגבלים
לחשבון </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
פעיל אחד. כל
חשבון נוסף
שייקבע כי
נוצר כדי
לעקוף הנחיות,
לקדם יתרונות
תחרותיים, או
להטעות את קהילת
</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> יושבת.
יצירת
חשבונות
מרובים
בהמוניה
עלולה לגרום
להשבתה של כל
החשבונות
הקשורים.
הערה: כל הפרה
של תנאי </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
עלולה להוות
עילה להשעיה
קבועה של כל
החשבונות.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-right:36.0pt;text-align:right;
text-indent:-18.0pt;direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span dir="RTL"></span><span lang="AR-SA">שימוש
לרעה ממוקד -
איננו סובלים
משתמשים המעורבים
בשימוש לרעה
ממוקד או
הטרדה כלפי
משתמשים
אחרים ב-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>. זה
כולל יצירת
חשבונות
מרובים חדשים
כדי להטריד
חברים
באמצעות
מערכת
ההודעות או
ההזמנות שלנו.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:0cm;margin-right:36.0pt;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;text-indent:-18.0pt;
direction:rtl;unicode-bidi:embed"><span lang="EN">●<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span dir="RTL"></span><span lang="AR-SA">מכירת
חשבונות -
אינך רשאי
לקנות או
למכור חשבונות
</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>8.6
מחלוקות
וביטולים</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">אנו
מעודדים את
הצרכנים
והספקים שלנו
לנסות ליישב
סכסוכים
ביניהם. אם
מסיבה כלשהי
זה נכשל לאחר
שימוש במרכז
יישוב
הסכסוכים או
אם אתה נתקל
בשימוש שאינו
מותר באתר,
משתמשים
יכולים ליצור
קשר עם מחלקת
תמיכת
הלקוחות של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> לסיוע [כאן].
למידע נוסף על
מחלוקות,
ביטולי הזמנות
והחזרים
כספיים, עיין
בתנאי התשלום.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>8.7
מיתון תוכן,
הודעות
וערעורים</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> אינה
מחויבת בדרך
כלל לבדוק
באופן יזום את
התוכן שפורסם
על ידי
משתמשים לגבי
חוקיותו או התאמתו
לתנאים. אנו
רשאים, עם זאת,
לבצע בדיקות וולונטריות
מיוזמתנו כדי
לזהות ולקבוע
תוכן בלתי
חוקי או בלתי
תואם ולנקוט
בצעדים מתאימים.
אנו עשויים
לנקוט
בפעולות
מתאימות אם אנו
מוצאים, או
מקבלים הודעה
על, הפרה של
התנאים. למידע
נוסף על
תהליכי מיתון
התוכן שלנו,
עיין [כאן].</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">אם </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
נוקטת בפעולה
נגדך, חשבונך
או תוכן, תוכל
להגיש תלונה
נגד החלטה זו.
תוכל גם להגיש
תלונה אם אינך
מסכים
להחלטתנו
בעקבות הודעה
שהגשת. בשני
המקרים, המועד
האחרון להגשת
תלונה הוא שישה
חודשים ממועד
ההודעה על
ההחלטה
הרלוונטית
אליך. תוכל
להגיש תלונה
על ידי יצירת
קשר עם תמיכת
הלקוחות שלנו.
אנא הסבר
בתלונתך מדוע
לדעתך עלינו
לבטל את
החלטתנו.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">אנו נטפל
בתלונות
באופן מהיר,
לא מפלה, חרוץ
ואובייקטיבי
ונבטל את
החלטתנו אם
נגיע למסקנה
שהיא ננקטה
בטעות.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">אם מקום
המגורים או
המיקום שלך
נמצאים באזור הכלכלי
האירופי (</span><span lang="EN" dir="LTR">EEA</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>),
תוכל לבחור
גוף ליישוב
סכסוכים מחוץ
לבית המשפט
שאושר בהתאם
לסעיף 21(3) של חוק
השירותים הדיגיטליים
של האיחוד
האירופי ("גוף
ליישוב סכסוכים")
כדי לפתור
מחלוקות
הקשורות
להחלטותינו
בנוגע לתוכן
שהעלית או
להודעות
שהגשת, לרבות
תלונות
שמערכת
הטיפול
בתלונות
הפנימית שלנו
לא פתרה.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">אנו
שומרים
לעצמנו את
הזכות לסרב
לשתף פעולה עם
גוף יישוב
הסכסוכים
שנבחר אם: (</span><span lang="EN" dir="LTR">i</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>)
המחלוקת
הרלוונטית
כבר נפתרה או
כבר כפופה להליך
מתמשך בפני
בית המשפט
המוסמך או
בפני גוף
יישוב
סכסוכים
מוסמך אחר; או (</span><span lang="EN" dir="LTR">ii</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>)
תקופת שישה
החודשים
ממועד ההודעה
על החלטתנו
אליך חלפה
מבלי שהגשת
תלונה
באמצעות
מערכת הטיפול
בתלונות
הפנימית שלנו
או פנית לגוף
יישוב
הסכסוכים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">החלטותיהם
של גופי יישוב
סכסוכים אינן
מחייבות אף
אחד מהצדדים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>8.8
הגבלות
קנייניות</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">האתר,
לרבות
תכונותיו,
הפריסה
הכללית, המראה
והתחושה,
העיצוב,
המידע, התוכן
וחומרים
אחרים הזמינים
בו (למעט </span><span lang="EN" dir="LTR">UGC</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>), וכל
זכויות
הקניין
הרוחני
הקשורות אליו,
הם בבעלות
בלעדית של </span><span lang="EN" dir="LTR">Keilot. Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>® וכל סימני
מסחר רשומים
אחרים הם
בבעלות בלעדית
של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.
למשתמשים אין
זכות, והם
מסכימים
במפורש לא לעשות
את הדברים
הבאים ביחס
לאתר או לכל
חלק, רכיב או
הרחבה של האתר
(לרבות
יישומיו
הניידים ולרבות
כל רכיב או
טכנולוגיה של
צד שלישי המשמשים
להפעלת האתר
או כל אחת
מתכונותיו): (</span><span lang="EN" dir="LTR">i</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>)
להעתיק,
להעביר,
להתאים,
לשנות, להפיץ,
לשדר, להציג,
ליצור יצירות
נגזרות, לפרסם
או לשכפל
אותו, בכל דרך
שהיא; (</span><span lang="EN" dir="LTR">ii</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>)
לגשת אליו, או
להשתמש בכל
מסירה, על מנת
לפתח או לבנות
מוצרים או
תכונות דומים
או תחרותיים, לחפש
לרכוש כל
עניין בעלות
או רישיון,
למכור, להעביר,
להשכיר זמן,
או להשכיר
אותו (או
לנסות כל אחד
מהאמור לעיל); (</span><span lang="EN" dir="LTR">iii</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>)
לבצע הנדסה
הפוכה, לפרק,
להנדס לאחור
או לנסות בדרך
אחרת להפיק את
קוד המקור
שלו, רעיונות בסיסיים,
אלגוריתמים,
מבנה או
ארגון; (</span><span lang="EN" dir="LTR">iv</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>) להסיר
כל הודעת
זכויות
יוצרים, זיהוי
או כל הודעות
קנייניות
אחרות; (</span><span lang="EN" dir="LTR">v</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>)
להשתמש
בתוכנת
אוטומציה
(בוטים),
פריצות, שינויים
(מודים) או כל
תוכנת צד
שלישי בלתי
מורשית אחרת
שנועדה לשנות
את האתר; (</span><span lang="EN" dir="LTR">vi</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>)
לנסות להשיג
גישה בלתי
מורשית,
להפריע, לגרום
נזק או לשבש
את האתר או את
מערכות המחשב
או הרשתות
המחוברות
לאתר; (</span><span lang="EN" dir="LTR">vii</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>)
לעקוף, להסיר,
לשנות,
להשבית,
להוריד או
לסכל כל אמצעי
טכנולוגי או
הגנות תוכן של
האתר; (</span><span lang="EN" dir="LTR">viii</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>)
להשתמש בכל
רובוט, עכביש,
סורקים או
מכשיר אוטומטי
אחר, תהליך,
תוכנה או
שאילתות
שמיירטים,
"כורים",
מגרדים או
ניגשים לאתר
בדרך אחרת כדי
לפקח, לאחזר,
לחלץ, להעתיק
או לאסוף תוכן
או נתונים
מהאתר או
דרכו, או
לעסוק בכל
תהליך ידני
כדי לעשות את
אותו הדבר; (</span><span lang="EN" dir="LTR">ix</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>)
לאחזר באופן
שיטתי נתונים
או תוכן אחר
כדי ליצור או
להרכיב,
במישרין או
בעקיפין,
אוסף, לקט,
מאגר נתונים,
או ספרייה; (</span><span lang="EN" dir="LTR">x</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>)
להחדיר כל
וירוסים,
סוסים
טרויאניים,
תולעים, פצצות
לוגיקה או
חומרים אחרים
שהם זדוניים או
מזיקים
מבחינה
טכנולוגית
למערכות שלנו;
(</span><span lang="EN" dir="LTR">xi</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>) להשתמש
באתר בכל אופן
שעלול לגרום
נזק, להשבית,
להכביד או
לפגוע באתר,
או להפריע
להנאתם של
משתמשים
אחרים מהאתר;
או (</span><span lang="EN" dir="LTR">xii</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>) לגשת
לאתר או
להשתמש בו בכל
דרך שאינה
מותרת במפורש
על ידי
התנאים.
משתמשים
מסכימים גם לא
לאפשר או להסמיך
אף אחד אחר
לעשות כל אחד
מהאמור לעיל.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">למעט
הזכות
המוגבלת
להשתמש באתר
בהתאם לתנאי
שימוש אלה, </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> היא
הבעלים של כל
הזכויות,
הכותרות
והאינטרסים
באתר (לרבות
כל זכויות
הקניין
הרוחני בו) ואתה
מסכים לא
לנקוט
בפעולה/ות
כלשהי/ן
שאינה/ן
עולה/ות בקנה
אחד עם
אינטרסים
בעלותיים אלה.
אנו שומרים
לעצמנו את כל
הזכויות בקשר
לאתר ולתוכנו
(למעט </span><span lang="EN" dir="LTR">UGC</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>)
לרבות, ללא
הגבלה, הזכות
הבלעדית
ליצור יצירות
נגזרות.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>8.9
זכויות משוב</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">במידה
שתספק ל-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
הערות, הצעות
או משוב אחר
כלשהו בנוגע
לאתר, וכן
למוצרים או
שירותים
אחרים של </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
(יחד, "המשוב"),
תיחשב כמי
שהענקת ל-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
זכויות בעלות
בלעדיות, ללא
תמורה, בתשלום
מלא, נצחיות,
בלתי חוזרות
וכלל עולמיות
במשוב. </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>
אינה מחויבת
ליישם כל משוב
שעשויה לקבל
ממשתמשים.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>8.10
סודיות</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">ספקים
צריכים להכיר
בכך שייתכן
ויהיה צורך מצד
צרכנים לחשוף
מידע סודי
מסוים לשימוש
על ידי ספקים
למטרת אספקת
השירותים,
וכדי להגן על מידע
סודי זה מפני
שימוש וגילוי
בלתי מורשים. לכן,
ספקים
מסכימים לטפל
בכל מידע
שיתקבל מצרכנים
כחומר רגיש
ביותר, סודי
ביותר ומסווג.
מבלי לגרוע
מכלליות
האמור לעיל,
ספקים
מסכימים במפורש
(</span><span lang="EN" dir="LTR">i</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>) לשמור על
כל מידע כזה
בסודיות
מוחלטת; (</span><span lang="EN" dir="LTR">ii</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>) לא
לגלות את
המידע לצדדים
שלישיים
כלשהם; (</span><span lang="EN" dir="LTR">iii</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>) לא
להשתמש במידע
לשום מטרה
מלבד אספקת
השירותים; ו-(</span><span lang="EN" dir="LTR">iv</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>)
לא להעתיק או
לשכפל כל חלק
מהמידע ללא
רשות הצרכן.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>9.
בעלות</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>9.1
בעלות
ומגבלות: בעת
רכישת שירות
ב-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>, אלא אם
צוין אחרת
במפורש בדף
השירות/תיאור
הספק או בהצעה
המותאמת
אישית, כאשר
העבודה נמסרת,
ובכפוף
לתשלום, הצרכן
מקבל את כל
זכויות הקניין
הרוחני, לרבות
אך לא רק,
זכויות
יוצרים בעבודה
שנמסרה מהספק,
והספק מוותר
על כל הזכויות
המוסריות (ככל
שהדבר מותר על
פי החוק החל) בהן.
בהתאם לכך,
הספק מקצה
במפורש לצרכן
את זכויות
היוצרים
בעבודה
שנמסרה. כל
העברה והקצאה
של קניין
רוחני לצרכן
יהיו כפופות
לתשלום מלא,
ואין להשתמש
במסירה אם
התשלום בוטל
מכל סיבה
שהיא. למען
הסר ספק,
בעבודה שנוצרה
בהתאמה אישית
(כגון יצירת
אמנות, עבודת
עיצוב, יצירת
דוחות וכו'),
העבודה
שנמסרה
וזכויות
היוצרים בה
יהיו קניינו
הבלעדי של
הצרכן, ועם
המסירה, הספק
מסכים כי הוא
מקצה בזאת,
בהתאם לתנאים,
את כל
הזכויות,
הכותרות
והאינטרסים בעבודה
שנמסרה לצרכן.
חלק
מהשירותים
(לרבות עבודה
שנוצרה
בהתאמה אישית)
גובים
תשלומים נוספים
(באמצעות
תוספות שירות)
עבור רישיון
שימוש מסחרי.
משמעות הדבר
היא שאם רכשת
את השירות לשימוש
אישי, תהיה
הבעלים של כל
הזכויות הנדרשות
לשימוש כזה,
ולא תצטרך את
רישיון
השימוש המסחרי.
אם בכוונתך
להשתמש בו לכל
תשלום או
תמורה אחרת,
או לכל מטרה
הקשורה במישרין
או בעקיפין
לכל עסק, או
מיזם אחר
המיועד לרווח,
תצטרך לרכוש
את רישיון
השימוש
המסחרי באמצעות
תוספת שירות
ותהיה בעל
זכויות רחבות
יותר המכסות
את השימוש
העסקי שלך.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">יתר על כן,
משתמשים (גם
צרכנים וגם
ספקים) מסכימים
כי אלא אם
ציינו במפורש
אחרת, התוכן
שמשתמשים
יוצרים/מעלים
מרצונם ל-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>,
לרבות טקסטים
של שירותים,
תמונות,
סרטונים, שמות
משתמש, תמונות
משתמש, תגובות
</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>, סרטוני
משתמשים וכל
מידע אחר,
לרבות הצגת עבודה
שנמסרה, עשוי
לשמש את </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> ללא
תמורה למטרות
שיווק ו/או
למטרה אחרת
הרלוונטית
לתפעול
ולתפקוד האתר.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>9.2
רישיון שימוש
מסחרי</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">על ידי
רכישת
"רישיון
שימוש מסחרי"
עם הזמנתך,
הספק מעניק לך
רישיון נצחי,
בלעדי, בלתי
ניתן להעברה,
כלל עולמי,
לשימוש
במסירה
שנרכשה למטרות
מסחריות
מותרות. למען
הסר ספק, הספק
שומר על כל
זכויות
הבעלות.
"מטרות מסחריות
מותרות"
פירושן כל
שימוש הקשור
לעסק, כגון
(לדוגמה)
פרסום, קידום,
יצירת דפי
אינטרנט, שילוב
במוצר, תוכנה
או כלים
עסקיים אחרים
וכו', ואינו
כולל כל מטרה
בלתי חוקית,
בלתי מוסרית או
משמיצה.
רישיון זה
כפוף לתנאי </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>. אין
אחריות,
מפורשת או
משתמעת, עם
רכישת מסירה
זו, לרבות
ביחס להתאמה
למטרה מסוימת.
לא הספק ולא </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> יהיו
אחראים לכל
תביעות, או
נזקים מקריים,
תוצאתיים או
אחרים
הנובעים
מרישיון זה,
המסירה או
שימושך
במסירה.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>10.
ויתור על
אחריות</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">שימושך
באתר, בתוכן
שלו,
בתכונותיו,
בשירותיו ובתוכניותיו,
ובכל שירותים
או פריטים
שהושגו
באמצעות האתר,
הוא על
אחריותך
הבלעדית. האתר,
תוכנו,
תכונותיו,
שירותיו
ותוכניותיו,
וכל שירותים
או פריטים
שהושגו
באמצעות האתר,
מסופקים על
בסיס "כפי
שהם" ו"כפי
שזמינים", ללא
כל אחריות מכל
סוג שהוא, בין
אם מפורשת
ובין אם משתמעת,
ובתנאי
שפעלנו
בחריצות
מקצועית סבירה.
לא </span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> ולא כל
גורם הקשור ל-</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> אינם
נותנים כל
אחריות או מצג
ביחס לשלמות,
אבטחה,
אמינות,
איכות, דיוק
או זמינות
האתר.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">האמור
לעיל אינו
משפיע על כל
אחריות שלא
ניתן לשלול או
להגביל על פי
החוק החל.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="EN" dir="LTR">11<span style="color:yellow">.<span style="background:black"> </span></span></span><span lang="AR-SA">תרגום
מכונה</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">תוכן
מסוים שנוצר
על ידי
משתמשים באתר
תורגם לנוחיותך
באמצעות
תוכנת תרגום
המופעלת על ידי
[</span><span lang="EN" dir="LTR">Google</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> / שירות
תרגום אחר, אם
רלוונטי].
נעשו מאמצים
סבירים לספק
תרגום מדויק,
אולם אף תרגום
אוטומטי אינו
מושלם ואינו
נועד להחליף
מתרגמים אנושיים.
תרגומים כאלה
ניתנים
כשירות
למשתמשי האתר,
ומסופקים
"כפי שהם". לא
ניתנת כל
אחריות מכל
סוג שהוא, בין
אם מפורשת
ובין אם
משתמעת, לגבי
הדיוק,
האמינות או
הנכונות של
תרגומים כאלה
שנעשו
מאנגלית לכל
שפה אחרת.
תוכן מסוים
שנוצר על ידי
משתמשים (כגון
תמונות,
סרטונים, פלאש
וכו') עשוי שלא
להיות מתורגם
במדויק או
בכלל עקב
מגבלות תוכנת
התרגום.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="EN" dir="LTR">[Google</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span> / שירות
תרגום אחר, אם
רלוונטי]
מתנער מכל
אחריות
הקשורה
לתרגומים,
מפורשת או
משתמעת, לרבות
כל אחריות
לדיוק,
אמינות, וכל
אחריות
משתמעת לסחירות,
התאמה למטרה
מסוימת
ואי-הפרה.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">הטקסט
הרשמי הוא
הגרסה
האנגלית של
האתר. כל אי
התאמות או
הבדלים
שנוצרו
בתרגום אינם
מחייבים ואין
להם תוקף
משפטי למטרות
עמידה או אכיפה.
אם מתעוררות
שאלות כלשהן
הקשורות
לדיוק המידע
הכלול בתוכן
המתורגם, אנא
עיין בגרסה
האנגלית של
התוכן שהיא
הגרסה הרשמית</span><span dir="LTR"></span><span lang="EN" dir="LTR"><span dir="LTR"></span>.</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>12.
הגבלת אחריות</span></p>

<p class="MsoNormal" dir="RTL" style="margin-top:12.0pt;margin-right:0cm;
margin-bottom:12.0pt;margin-left:0cm;text-align:right;direction:rtl;unicode-bidi:
embed"><span lang="AR-SA">בתנאי
שפעלנו
בחריצות
מקצועית
סבירה, בשום מקרה
</span><span lang="EN" dir="LTR">Keilot</span><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>,
שלוחותיה או
מעניקי
הרישיונות
שלהן, ספקי השירותים,
העובדים,
הסוכנים,
המנהלים או
הדירקטורים
שלהן לא יהיו
אחראים
לנזקים מכל
סוג שהוא, על
פי כל תיאוריה
משפטית,
הנובעים מ- או
בקשר לשימושך,
או חוסר
יכולתך
להשתמש, באתר,
בכל אתר
המקושר אליו,
התנהלות
צדדים
שלישיים, כל
תוכן באתר או
שירותים/פריטים
שהושגו דרך
האתר.</span></p>

</div>




</body></html>`;

export default heTosHtml;
